import { Component, OnInit, ChangeDetectionStrategy, input, Input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { RqaMenuItem } from '@app/shared/models/menu.model';
import { IconComponent } from '@pansa/ui';

@Component({
  selector: 'rqa-menu',
  standalone: true,
  imports: [RouterModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ul class="layout-menu">
      @for (item of model; track item; let i = $index) {
        @if (!item.separator) {
          <li class="layout-menuitem-category">
            <ul>
              @for (child of item?.items; track child) {
                <li>
                  <a
                    [routerLink]="child.routerLink"
                    routerLinkActive="active-route"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="p-ripple"
                  >
                    <pui-icon [icon]="child.icon"></pui-icon>
                    @if(!collapsed){
                      <span>{{ child?.label ?? ''}}</span>
                    }
                  </a>
                </li>
              }
            </ul>
          </li>
        }
        @if (item.separator) {
          <li class="menu-separator"></li>
        }
      }
    </ul>
  `
})
export class RqaMenuComponent implements OnInit {
  model: RqaMenuItem[] = [];
  @Input() collapsed = false;

  ngOnInit() {
    this.model = [
      {
        label: 'Menu',
        icon: '',
        items: [
          { label: 'Strona główna', icon: 'home-line', routerLink: ['/'] },
          { label: 'Podmioty uprawnione', icon: 'briefcase-01', routerLink: ['/authorized-entity'] },
          { label: 'Użytkownicy', icon: 'user-01', routerLink: ['/users'] },
          { label: 'Grupy', icon: 'users-01', routerLink: ['/groups'] },
          { label: 'Wiadomości', icon: 'mail-03', routerLink: ['/messages'] },
          { label: 'Wydarzenia', icon: 'calendar', routerLink: ['/events'] },
          { label: 'Pomoc', icon: 'help-circle', routerLink: ['/help'] }
        ]
      }
    ];
  }
}
